import * as XLSX from 'xlsx';
export default {


  data() {
    return {
      search: '',
      columnas_declaraciones: [

        {text:"NIT", value:"nit"},
        {text:"Cliente a presentar", value:"nombre"},
        {text:"Número de formulario", value:"numero_formulario"},
        {text:"ROS - IVA ", value:"impuesto_pagar_debitos"},
        {text:"ROS/PC - ISR", value:"pago"},


      ],
      filas_declaraciones: [],

      fecha: '',
      fecha_aux: '',
      colaborador_id: null,
      menu_fec:null,

      colaborador: [],

      loading_colaboradores: false,
      loadingInformacion: false,
    }
  },

  async created() {
    await this.getListadoEmpleados();
  },

  watch:{
    fecha(){
      this.fecha_aux = this.fecha.toString().split("-").reverse().join("/")
    }
  },

  methods: {

    convertirnumero(numero) {
      let dollarUSLocale = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
      return dollarUSLocale.format(Math.abs(numero))

    },

    exportarExcel() {
      let info = [];
      this.filas_declaraciones.forEach(element => {

        let data = {
          NIT: element.nit,
          CLIENTE_A_PRESENTAR: element.nombre,
          NUMERO_FORMULARIO: element.numero_formulario,      
          PAGO_IMPUESTO: element.pago,
        }
        info.push(data);
      });
      console.log("info");
      console.log(info);
      let data = XLSX.utils.json_to_sheet(info)
      const workbook = XLSX.utils.book_new()
      const filename = 'pendientes_confirmar'+this.fecha;
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    },

    
    async getReporteSeguimientoPago() {
      try {
        this.loadingInformacion = true;
        let r = await this.$store.state.services.reportesService.getReporteSeguimientoPago(this.fecha, this.colaborador_id);
        console.log(r);
        this.filas_declaraciones = r.data.data;
        this.loadingInformacion = false;
      } catch (error) {
        console.log(error);
        this.loadingInformacion = false;
      }
    },

    limpiardata(){
      this.fecha = '';
      this.colaborador_id = null;
      this.filas_declaraciones = [];

    },

    async getListadoEmpleados(){
      try {
        this.loading_colaboradores = true;
        let r = await this.$store.state.services.administradorService.getListadoEmpleados();
        console.log(r);
        this.colaborador = r.data.data;
        this.loading_colaboradores = false;
      } catch (error) {
        console.log(error);
        this.loading_colaboradores = false;

      }
    },


  }
}